export default function cookieModel($rootScope) {
    var obj = this;

    /**
     * Collect cookie details from each Script to Loader
     * cookiesToAdd [array]
     * : SiteImprove
     * : ...
     * : ...
     **/

    $rootScope.$on("add-cookies-to-model", function (e, cookiesToAdd) {
        angular.forEach(cookiesToAdd.cookies, function (cookieToAdd) {
            angular.forEach(obj.cookies, function (category) {
                if (category.name == cookieToAdd.category) {
                    category.cookies.push(cookieToAdd);
                }
            });
        });
    });

    obj.cookies = [
        /**
         * Functional Category
         */
        {
            name: "functional",
            title: "Nødvendige",
            checked: true,
            required: true,
            cookies: [
                // {
                //     name: ".ASPXAUTH",
                //     issuer: "Abook",
                //     purpose:
                //         "Used to check if the user is authenticated and contains the encrypted data to identify him on each page load.",
                //     expirery: "Session",
                //     type: "http",
                //     storageType: "cookie",
                //     category: "functional",
                // },
                {
                    name: "ASP.NET_SessionId",
                    issuer: "Abook",
                    purpose:
                        "Used to identify the users session on the server. The session being an area on the server which can be used to store session state in between http requests",
                    expirery: "Session",
                    type: "http",
                    storageType: "cookie",
                    category: "functional",
                },
                {
                    name: "abook.cookieCompliance",
                    issuer: "Abook",
                    purpose:
                        "Used to identify which cookie categories the user allows",
                    expirery: "365 dage",
                    type: "http",
                    storageType: "cookie",
                    category: "functional",
                },
            ],
        },

        /**
         * STATISTICS Category
         */
        {
            name: "statistics",
            title: "Statistik",
            checked: false,
            required: false,
            cookies: [
                /**
                 * Injections
                 *
                 * SITEIMPROVE
                 */
            ],
        },

        /**
         * Marketing Category
         */
    ];

    return obj;
}
